import { AboutIntro, AsideBanner, Attractions, DateSearchBar, PhotoFeed } from "@/domains/components";
import { useBookingRecoilValue } from "@/shared/client";
import { useGetCommon, type MainInfoResponse } from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { Banner } from "@components/banner";

export const About = () => {
    const { data } = useGetCommon<MainInfoResponse>({ section: "main" });
    const bookingEngine = useBookingRecoilValue();

    return data ? (
        <Box w="100%">
            <Box position="relative">
                <Banner imgList={data.imgList} catchPraise={data.catchPraise} />
                {!bookingEngine.isGoogleBE && <DateSearchBar isSubMenu />}
            </Box>
            <PhotoFeed />
            <AboutIntro />
            <AsideBanner isFullImg={false} />
            <Attractions />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
